import { getProduct, getWeCom } from "@/api/api";
import { decryptAES } from "@/utils";
import router from '@/router';
import {setStorage, getStorage, removeStorage} from '@/libs/Storage'
import { IDcardrecognition,AuthorizationConsented } from "@/api/account";
import {clickSave} from '@/api/account'
import Vue from 'vue'
const state = () => ({
  formData: getStorage('formData') || {
    phone:getStorage('phone') || '',
    name: '',
    id_card: '',
    zhima: null,
    is_readys: true,
    is_ready: false,

    
  }, 
  productSelectedArray: getStorage('productSelectedArray') || [],
   downLoadSelectedArray: getStorage('downLoadSelectedArray') || [],
  sesamesList: [
    {value: 0, name: '500分以下'},
    {value: 1, name: '550分-599分'},
    {value: 2, name: '600分-649分'},
    {value: 4, name: '700分以上'},
  ],
  noticeList: [
    { name: '李女士', amount: '60000', time: '3分钟前'},
    { name: '王女士', amount: '50000', time: '2分钟前'},
    { name: '张先生', amount: '100000', time: '3分钟前'},
    { name: '陈女士', amount: '70000', time: '5分钟前'},
  ],
  productList: [],
  wecomList: [],
  downloadList: getStorage('downData') || []
});

const mutations = {
  productList: (state, data) => {
    state.productList = data;
  },
  wecomList: (state, data) => {
    state.wecomList = data;
  },
  productSelectedArray: (state, data) => {
    state.productSelectedArray = data;
    // setStorage('productSelectedArray', data, 'local');
  },
    moveProductToEnd(state, productId) {
    const index = state.productList.findIndex(p => p?.id === productId);
    if (index >= 0) {
      const item = state.productList[index];
      state.productList.splice(index, 1);
      state.productList.push(item);
      
      // 不需要存储到本地，保持原排序
      // 因为这只是临时移动，不是永久排序
    }
  },
  downLoadSelectedArray: (state, data) => {
    state.downLoadSelectedArray = data;
    // setStorage('downLoadSelectedArray', data, 'local');
  },
  downloadList: (state, data) => {
    state.downloadList = data;
    setStorage('downData', data, 'local');
    console.log(getStorage('downData'),'downData取');
    return
    
  },
  updateFormData: (state, payload) => {
    state.formData = { ...state.formData, ...payload };
    // setStorage('formData33', state.formData, 'local');
  },
  updateFormField: (state, { key, value }) => {
    if (key in state.formData) {
      state.formData[key] = value;
      console.log('[ value ] >', value)
      setStorage('formData', state.formData, 'local');
    }
  },
  resetFormData: (state) => {
    state.formData = {
      phone: '',
      name: '',
      id_card: '',
      // idcard_image_front: '',
      // idcard_image_back: '',
      zhima: null,
      is_ready: false,
      is_readys:false,
      // ocrResult: null
    };
    removeStorage('formData22');
  }
};

const actions = {
     async requestWithRedirect({ commit, state,dispatch }, { 
    url, 
    apiFunc, 
    params, 
    name, 
    selectedId,
    needJump = true,
    loadingText = '处理中...',
    successMsg,
    errorMsg = '请求失败，请重试'
  }) {
    let loading = null;
    try {
      // 显示加载提示
      if(loadingText) {
        loading = Vue.prototype.$baseLoading(loadingText);
      }
  
    
      const res = await apiFunc(params);
      if(res.code==200){
        // 在 Vuex action 中修改这部分逻辑
        if (name === 'download' || name === 'wechat'||name==='lianDeng') {
          // 使用映射关系确定index
          const indexMap = { download: 0, wechat: 1,lianDeng:2 };
          const index = indexMap[name] ?? 0; // 默认使用0
          console.log('[ selectedId ] >', selectedId)
          // 拷贝当前数据
          const currentData = { ...state.downloadList };
          
          // 确保目标数组存在
          if (!Array.isArray(currentData[index])) {
            currentData[index] = [];
          }

          const originalLength = currentData[index].length;
          
          // 过滤数组 - 添加更安全的判断
          currentData[index] = currentData[index].filter(item => 
            item?.plan?.id !== selectedId
          );
            setTimeout(() => {
                commit('downloadList', currentData);
            }, 1500);
        
          console.log('[ currentData ] >', currentData)
          
          if(name=='wechat'){
             await dispatch("clickCount", {
              params: { wechatTiaozhuan: 1 },
              });
              
          }
            if(name=='lianDeng'){
              await dispatch("clickCount", {
             params: { lianDengId: 1 },
         });
              
          }
        
     
          if (originalLength > 0 && currentData[index].length == 0) {
            console.log(`${name}列表已空，跳转到产品页`);
            // setTimeout(() => {
                router.replace({ name: 'home_product' });
            // }, 2000);
          
          }
        }else {
          // 处理 product 情况
            let storedArray = getStorage('productSelectedArray', 'local') || [];
            
            storedArray = storedArray.filter(id => id !== selectedId);
            storedArray.push(selectedId);
            
            commit('productSelectedArray', [...storedArray]);
            setStorage('productSelectedArray', [...storedArray], 'local');
          }

      }
      // 关闭加载提示
      if(loading) loading.clear();
      
      if (res.code !== 200) {
        Vue.prototype.$baseMessage(errorMsg || res.msg || '请求失败', 'error');
        return res;
      }
      
      // 显示成功提示
      if(successMsg) {
        Vue.prototype.$baseMessage(successMsg, 'success');
      }
      
      if (needJump && url) {
           console.log(needJump,'needJump');
             console.log(url,'url');
                 console.log(url.startsWith('http'),'startsWith');
        
   
        
        if (url.startsWith('http')) {
          // 外部链接
            window.location.href=url
              return // 终止后续逻辑
        } 
        else {
          // 内部路由
          router.push(url);
        }
      }
      
      return res;
    } catch (error) {
      // 关闭加载提示
      if(loading) loading.clear();
      
      Vue.prototype.$baseMessage(errorMsg || error.message || '请求异常', 'error');
      // throw error;
    }
  },
async handleApiWithRedirect({ commit, state, dispatch }, { params, apiFunc,loading }) { 
    // If no cached data, proceed with API call
    const res = await apiFunc(params);
    const { data, code, msg } = res;
  
    // 解密数据（如果有）
    let returndata = null;
    if (data) {
      returndata = decryptAES(data);
      // 存储返回数据到downloadList
      commit("downloadList", returndata);

    }

    // 保存表单数据到state（无论是否有data都执行）
    commit('updateFormData', {
      phone: params.phone,
      verifycode: params.captcha,
    });
      // 下面的其他界面跳转暂时注销
    // 根据状态码处理
    if (code === 200) {
      console.log('[ returndata ] >', returndata)
      if(returndata.customer.product_audit_status==0){
       router.push({ name: 'home_waitPage' });
      }else if(returndata.customer.product_audit_status==1){
      router.push({ name: 'home_product' });
      }else{
        router.push({ name: 'home_downpage' });
      }
      // code为200时的跳转逻辑
      
    
    }else if(code === 230){
        router.push({ name: 'home_assessment' });
    } else if (code == 500) {
      console.error('服务器错误:', msg);
       router.push({ name: 'home_downpage' });
    
    }
    
    return returndata;
   
},


async clickCount({ commit, state, dispatch }, { params, apiFunc }) {
    // First, construct the base object
    const baseObj = {
        channel_code: getStorage('code'),
        customer_id: getStorage('customer').id,
        ...(params.downloadId && { three_element_click: params.downloadId }),
        ...(params.productId && { dc_click: params.productId }),
        ...(params.lianDengId && { liandeng_click: params.lianDengId }),
    };

  
    // Handle WeChat parameters (wechatTiaozhuan takes priority and clears wechatId)
    const wechatParams = {};
    if (params.wechatTiaozhuan) {
        wechatParams.enterprise_wechat_match_agree_click = params.wechatTiaozhuan;
        // Explicitly set wechatId to undefined to ensure it's not included
        wechatParams.enterprise_wechat_match_click = undefined;
    } else if (params.wechatId) {
        wechatParams.enterprise_wechat_match_click = params.wechatId;
    }

    // Merge all parameters
    const finalObj = { ...baseObj, ...wechatParams };

    const res = await clickSave(finalObj);
    console.log('原始响应:', res);
    return res;
},

  async getProduct({ commit }) {
    const { data } = await getProduct();
    const product = decryptAES(data);
    commit('productList', product);
    return product;
  },

  async getWeCom({ commit }, param) {
    const { data } = await getWeCom(param);
    commit('wecomList', data);
    return data;
  },

  async performOCR({ commit,state }, { frontFile, backFile }) { 
    const formData = new FormData();
    // formData.append("idcard_image_front", frontFile);
    // formData.append("idcard_image_back", backFile);
    Vue.prototype.$baseLoading('识别身份证...')
    const result = await IDcardrecognition(formData);
    const { code, data, msg } = result;
    
    if (code === 200) {
      const returndata = decryptAES(data);
      console.log(state.formData,'fdsfsd');
      
      commit('updateFormData', {
        // idcard_image_front: returndata.idcard_image_front,
        // idcard_image_back: returndata.idcard_image_back,
        address: returndata.idcard_image_params?.address,
        birth:returndata.idcard_image_params?.birth,
        real_name:returndata.idcard_image_params?.real_name,
        // id_card:returndata.idcard_image_params?.idcard_number,
        ...returndata.idcard_image_params,
         name: returndata.idcard_image_params?.real_name,
         idcard_number: returndata.idcard_image_params?.idcard_number
      });
      return returndata;
    }else if(code==500){
        console.log('[ 5221111 ] >', 5221111)
          Vue.prototype.$baseMessage(msg, "error");
      }
  }
};

const getters = {
  sesamesList: state => state.sesamesList,
  productList: state => state.productList,
  downloadList: state => state.downloadList,
  formData: state => state.formData,
  // productSelectedArray:state => state.productSelectedArray,
  productSelectedArray: (state, data) => {
  state.productSelectedArray = data;

    },
  downLoadSelectedArray: (state, data) => {
    state.downLoadSelectedArray = data;

  },  

  // 简化后的sortedDownloadList
  sortedDownloadList: state => {
    // 获取原始数据（确保是数组）
    const downloadList = state.downloadList[0] || [];
    
    // 获取已移除的ID列表
    const removedIds = state.downLoadSelectedArray || getStorage('downLoadSelectedArray') || [];
    
    // 过滤掉已移除的项
    return downloadList.filter(item => !removedIds.includes(item?.plan?.id));
  }
  // sortedDownloadList: state => {
  //   const selectedIds = state.downLoadSelectedArray;
  //   const list = [...(state.downloadList[0] || [])];
  //   return list.sort((a, b) => {
  //     const aSelected = selectedIds.includes(a.id);
  //     const bSelected = selectedIds.includes(b.id);
  //     if (aSelected && !bSelected) return -1;
  //     if (!aSelected && bSelected) return 1;
  //     return 0;
  //   });
  // }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};